var qrCode = "https://shopfront-cdn.tekoapis.com/static/7534c48e46ec507e.svg";

export { qrCode as default };
